import React, {Component} from "react";
import TasksTable from "./table/TasksTable";
import TasksTableHeader from "./table/TasksTableHeader";
import TasksTableFooter from "./table/TasksTableFooter";
import {injectIntl} from "react-intl";
import {connect} from 'react-redux';
import User from '../../services/User'
import Storage from '../../services/Storage';

import "./Tasks.css";
import Constants from "../../services/Constants";
import {withRouter} from "react-router-dom";

import {
  appliedFilters,
  getFilters,
  getInitFilters,
  getInterventions,
  initPagination,
  isLoadingInterventions,
  isShowingArchived,
  pagination,
} from "../../selectors/fetchInterventions";
import * as types from "../../constants/ActionTypes";
import {LOCATION_KEY, PREVIOUS_LOCATION, SCROLL_POSITION} from "../../constants/storageKeys";

const TW0_MINUTES = 2 * 60 * 1000;

class Tasks extends Component {

  constructor(props) {
    super(props);
    this.state = {
      currentFilters: {
        ...this.nonArchivedFilter(),
        origins: User.isCallCenterAgent() ? Constants.ORIGIN_CALL_CENTER.value : undefined
      },
      showOnlyMine: false
    };
  }

  componentDidMount() {
    const {location} = this.props;
    const locationKey = Storage.getSessionItem(LOCATION_KEY) || null;
    const previousLocation = Storage.getSessionItem(PREVIOUS_LOCATION) || null;
    if (location.key) {
      if (location.key === locationKey) {
        this.restoreListLoad();
      } else {
        this.initListLoad();
      }
    } else {
      if (previousLocation === location.pathname) {
        this.restoreListLoad();
      } else {
        this.initListLoad();
      }
    }
    this.resetIntervalRefreshList();
  }

  componentWillUnmount() {
    this.releaseInterval()
  }

  releaseInterval = () => {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }


  resetIntervalRefreshList = () => {
    this.releaseInterval();
    this.interval = setInterval(() => this.onListRefresh(), TW0_MINUTES);
  }

  refreshListAndResetInterval = () => {
    this.onListRefresh();
    this.resetIntervalRefreshList();
  }

  getFilters = (initLoad = false) => {
    const {dispatchToggleArchived, dispatchResetFilters, initFilters, location, showArchived, filters, appliedFilters} = this.props;
    const urlParams = new URLSearchParams(location.search);
    const searchInterventions = urlParams.get("search");
    const filtersData = {...initLoad ? initFilters : appliedFilters};
    if (initLoad) {
      dispatchResetFilters();
      filtersData.interventionStatus = this.nonArchivedFilter().interventionStatus;
    } else {
      if (showArchived && filters.interventionStatus.length === 0 || searchInterventions) {
        filtersData.interventionStatus = [];
      }
    }
    if (searchInterventions) {
      filtersData.search = searchInterventions;
      initLoad && dispatchToggleArchived(true);
    } else {
      initLoad && dispatchToggleArchived(false);
    }
    return {...filtersData, origins: User.isCallCenterAgent() ? Constants.ORIGIN_CALL_CENTER.value : undefined};
  }

  initListLoad = () => {
    const {dispatchFetchInterventions, initPagination} = this.props;
    const filters = this.getFilters(true);
    dispatchFetchInterventions({
      page: initPagination.currentPage - 1,
      size: initPagination.currentPageSize,
    }, filters);
    window.scrollTo(0, 0);
  };

  restoreListLoad = () => {
    const {dispatchFetchInterventions, pagination: {currentPage, currentPageSize}} = this.props;
    const filters = this.getFilters();
    dispatchFetchInterventions({
      page: currentPage - 1,
      size: currentPageSize,
    }, filters);
    this.restoreScrollPosition();
  };

  restoreScrollPosition = () => {
    const scrollPosition = Storage.getSessionItem(SCROLL_POSITION) || null;
    if (scrollPosition) {
      window.scrollTo(0, parseInt(scrollPosition));
    }
    Storage.removeSessionItems([SCROLL_POSITION, LOCATION_KEY, PREVIOUS_LOCATION]);
  };

  onListRefresh = () => {
    const {filters, pagination} = this.props;
    this.updateContent(pagination.currentPage, pagination.currentPageSize, filters);
  };

  nonArchivedFilter = () => {
    const nonArchivedFilter = {};
    nonArchivedFilter.interventionStatus = Constants.STATUS_FILTER.map(s => s.value);
    return nonArchivedFilter;
  };

  updateContent(page, size, rawFilter) {
    const {appliedFilters} = this.props;
    const {showArchived, dispatchFetchInterventions} = this.props;
    const newFilter = {...rawFilter}
    // if all status filters are removed, we should put a default filter
    if (!showArchived && newFilter.interventionStatus && newFilter.interventionStatus.length < 1) {
      newFilter.interventionStatus = this.nonArchivedFilter().interventionStatus;
      if (showArchived) {
        newFilter.interventionStatus.push(Constants.STATUS_ARCHIVED.value)
      }
    }
    const filter = {...appliedFilters};
    const keys = Object.keys(newFilter);
    filter[keys] = newFilter[keys];
    dispatchFetchInterventions({page: page - 1, size: size}, filter);
  }

  setDataParameters(interventions) {
    const {pagination} = this.props;
    if ((interventions.content) && ((pagination.currentPage !== interventions.number + 1) || pagination.currentPageSize !== interventions.size)) {
      this.setState({
        data: interventions.content,
        currentPage: interventions.number + 1,
        currentPageSize: interventions.size,
      })
    }
  }

  onShowArchivedChange = (showArchived) => {
    const {dispatchToggleArchived, filters, dispatchSetFilters, pagination, initPagination} = this.props;
    dispatchToggleArchived(showArchived);
    let statusFilter = [...filters['interventionStatus'].filter(c => c !== Constants.STATUS_ARCHIVED.value)];
    if (statusFilter.length < 1) {
      statusFilter = this.nonArchivedFilter().interventionStatus;
      if (showArchived) {
        statusFilter.push(Constants.STATUS_ARCHIVED.value);
      }
    }
    if (showArchived) {
      this.updateContent(pagination.currentPage, pagination.currentPageSize, {'interventionStatus': statusFilter});
    } else {
      statusFilter = statusFilter.filter(c => c !== Constants.STATUS_ARCHIVED.value);
      const updatedFilters = {...filters};
      updatedFilters.interventionStatus = filters.interventionStatus.filter(c => c !== Constants.STATUS_ARCHIVED.value)
      dispatchSetFilters(updatedFilters);
      this.updateContent(initPagination.currentPage - 1, pagination.currentPageSize, {'interventionStatus': statusFilter});
    }
  };

  onShowOnlyMineChange = (showOnlyMine) => {
    const {pagination} = this.props;
    this.setState({showOnlyMine});
    this.updateContent(pagination.currentPage, pagination.currentPageSize, {'showOnlyMine': showOnlyMine});
  }

  render() {
    const {interventions, loading, showArchived, pagination, filters} = this.props;

    if (!loading) {
      this.setDataParameters(interventions);
    }

    return (
      <div className="box__body">
        <TasksTableHeader
          contentUpdater={(filter) => this.updateContent(1, pagination.currentPageSize, filter)}
          showArchived={showArchived}
          showOnlyMine={this.state.showOnlyMine}
          onShowArchived={this.onShowArchivedChange}
          onShowOnlyMine={this.onShowOnlyMineChange}
          onListRefresh={this.refreshListAndResetInterval}
          initListLoad={this.initListLoad}
        />
        <TasksTable
          contentUpdater={(filter) => this.updateContent(1, pagination.currentPageSize, filter)}
          showArchived={showArchived}
        />
        <TasksTableFooter
          contentUpdater={(page, size) => this.updateContent(page, size, filters)}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  interventions: getInterventions(state),
  loading: isLoadingInterventions(state),
  showArchived: isShowingArchived(state),
  pagination: pagination(state),
  initPagination: initPagination(state),
  filters: getFilters(state),
  initFilters: getInitFilters(state),
  appliedFilters: appliedFilters(state),
});

const mapDispatchToProps = dispatch => ({
  dispatchFetchInterventions: (parameters, filters) => dispatch({type: types.FETCH_INTERVENTIONS, parameters, filters}),
  dispatchToggleArchived: (showArchived) => dispatch({type: types.TOGGLE_ARCHIVED, showArchived}),
  dispatchSetFilters: (filters) => dispatch({type: types.SET_FILTERS, filters}),
  dispatchResetFilters: () => dispatch({type: types.RESET_FILTERS}),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(Tasks)));



// WEBPACK FOOTER //
// ./src/components/overview/Tasks.js